module.exports = {
    methods: {
        openVideoModal(url) {
            this.videoModalOpen = true;
            this.processVideoUrl(url);
        },

        closeVideoModal() {
            this.videoModalOpen = false;
            this.videoUrl = '';
            this.videoType = '';
        },

        processVideoUrl(url) {
            if (url.indexOf('youtube') > -1) {
                this.videoType = 'youtube';
                this.videoUrl = `${url}?rel=0`
            } else if (url.indexOf('vimeo') > -1) {
                this.videoUrl = url;
                this.videoType = 'vimeo';
            }
        }
    }
};



// WEBPACK FOOTER //
// ./resources/js/base.js